import cookies from "js-cookie";
import { signOut, SignOutParams } from "next-auth/react";

import { SESSION_COOKIE_NAME } from "../../../config/global.config";

const clearAuthSession = async (signoutOptions?: SignOutParams<boolean>) => {
    cookies.remove(SESSION_COOKIE_NAME);
    signOut(signoutOptions);
};

export default clearAuthSession;
